import { axiosInstance } from "../utils";
import { IDraftParagraph, IDraftParagraphCreate } from "../models/wall";

export const createDraftParagraph = async (data: IDraftParagraphCreate): Promise<IDraftParagraph> => {
  const response = await axiosInstance.post<IDraftParagraph>(`/draft-paragraphs/`, data);

  return response.data;
}
export const updateDraftParagraphApi = async (id: string, draft: Partial<IDraftParagraph>): Promise<IDraftParagraph> => {
  const response = await axiosInstance.patch<IDraftParagraph>(`/draft-paragraphs/${id}/`, draft);

  return response.data;
}
export const deleteDraftParagraph = async (id: string): Promise<void> => {
  const response = await axiosInstance.delete(`/draft-paragraphs/${id}/`);
}
export const moveDraftParagraphUp = async (id: string): Promise<void> => {
  const response = await axiosInstance.patch(`/draft-paragraphs/${id}/move-up/`);
}
export const moveDraftParagraphDown = async (id: string): Promise<void> => {
  const response = await axiosInstance.patch(`/draft-paragraphs/${id}/move-down/`);
}
